'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openModal = exports.closeModal = exports.options = exports.DEACTIVATE_MODAL = exports.ACTIVATE_MODAL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ACTIVATE_MODAL = exports.ACTIVATE_MODAL = 'RDX-MDL-DSPTCHR::ACTIVATE_MODAL';
var DEACTIVATE_MODAL = exports.DEACTIVATE_MODAL = 'RDX-MDL-DSPTCHR::DEACTIVATE_MODAL';

var options = exports.options = {};

var activateModal = function activateModal(dispatch, modalId) {
  return dispatch({
    type: ACTIVATE_MODAL, modalId: modalId
  });
};

var deactivateModal = function deactivateModal(dispatch, modalId) {
  return dispatch({
    type: DEACTIVATE_MODAL, modalId: modalId
  });
};

var clearOptions = function clearOptions(modalId) {
  return function () {
    delete options[modalId];
  };
};

var closeModal = exports.closeModal = function closeModal(modalId, result) {
  return function (dispatch) {
    var callOptions = options[modalId];
    if (callOptions) {
      deactivateModal(dispatch, modalId);
      clearOptions(modalId);
      callOptions.resolve(result);
    }
  };
};

var curryClose = function curryClose(modalId, dispatch) {
  return function (result) {
    return dispatch(closeModal(modalId, result));
  };
};

var bindClose = function bindClose(modalId, dispatch) {
  return function (result) {
    return function () {
      return dispatch(closeModal(modalId, result));
    };
  };
};

var createOptions = function createOptions(dispatch, modalId, params, resolve) {
  return {
    resolve: resolve,
    params: (0, _assign2['default'])({}, params, {
      close: curryClose(modalId, dispatch),
      bindClose: bindClose(modalId, dispatch)
    })
  };
};

var openModal = exports.openModal = function openModal(modalId, params) {
  return function (dispatch) {
    return new _promise2['default'](function (resolve) {
      options[modalId] = createOptions(dispatch, modalId, params, resolve);
      return activateModal(dispatch, modalId);
    });
  };
};